import React, { useState } from "react";
import { Button, Col, Form, Row } from "antd";
import CommentBox from "../../../components/commentBox";
import TaskCheckedList from "../../../components/taskCheckedList";
import PageHeader from "../../../components/pageHeader";
import { collection, doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../../../../../../firebase";

function SendWelcomeEmail({ itemId, listId, alreadyCheckedItems }) {
  const isItemChecked = alreadyCheckedItems[itemId.toString()]; // Convert itemId to string because keys in checkedItems are strings.

  const [isDisabled, setIsDisabled] = useState(isItemChecked);

  const tasksRef = collection(db, "tasks");
  const itemListRef = doc(tasksRef, "itemList");
  const assignedCollectionRef = collection(itemListRef, "Assigned");

  const handleComplete = async () => {
    const targetDocRef = doc(assignedCollectionRef, listId);

    try {
      const docSnapshot = await getDoc(targetDocRef);

      if (docSnapshot.exists()) {
        const data = docSnapshot.data();
        if (data && data.workItemList) {
          const updatedWorkItemList = data.workItemList.map((item) => {
            return {
              ...item,
              status:
                item.id == itemId && item.status == "incompleted"
                  ? "completed"
                  : item.status,
            };
          });

          await updateDoc(targetDocRef, {
            workItemList: updatedWorkItemList,
          });

          console.log("Document successfully updated!");
          setIsDisabled(true);
        } else {
          console.log("workItemList not found in the document!");
        }
      } else {
        console.log("Document does not exist!");
      }
    } catch (error) {
      console.error("Error updating document:", error);
    }
  };
  return (
    <div className="item-page">
      <Form className="item-page-container" layout="vertical">
        <Row gutter={[0, 24]}>
          <Col span={24}>
            <PageHeader pageHeading="Send Welcome Email" />
          </Col>
          <Col span={24}>
            <h3 className="green-info-text">Message to send</h3>
          </Col>
          <Col span={24}>
            <p>
              Congratulations on your new rental home! Below is helpful
              information for your upcoming move.
            </p>
          </Col>
          <Col span={24}>
            <p>
              Scheduling Your Move In I will be texting you a code to access the
              property on your move in date. This code will only work on that
              date. If you need to change for any reason please let us know. We
              will pick up the lockbox and sign from the door a few days after
              your move in. Make sure if you remove the sign to place it near
              the front door for pickup.
            </p>
          </Col>
          <Col span={24}>
            <p>Contacting Us</p>
            <p>
              There are several ways to reach our office, here is a link to our
              page with our contact info. https://integrityoklahoma.com/office/
              you can also reach us by text - (251)577-4036 -(our software will
              text you from an out of state number but will always say
              integrityokc at the bottom of the message) phone - (405)283-6521 -
              in the welcome msg you will hear an option to dial by name you can
              use this to contact me. email - just reply to this msg at any time
              and we will be happy to get back to you asap.
            </p>
          </Col>
          <Col span={24}>
            <p>Repair Requests</p>
            <p>
              If you have maintenance needs, please submit a repair request at
              https://integrityoklahoma.com/repairs/. These messages are
              reviewed on an hourly basis and will be assigned in order of
              priority and urgency. You can also text- (251)577-4036 (Text is
              preferred) or call (405)283-6521 and select option 2 for emergency
              after hours work orders although please submit an online work
              order as well. We also provide complimentary AC filters at move in
              for any tenant on our Tenant Benefit Package. If there were not
              filters in your home already you can fill out our request form to
              have filters sent to you. https://form.jotform.com/221338395142050
            </p>
          </Col>
          <Col span={24}>
            <p>Utilities</p>
            <p>
              We have submitted your contact information to Citizen Home
              Solutions. They are a concierge utility connection service. This
              service is completely free! They will be contacting you by phone
              to help set up your utilities. If you have not heard from them in
              the next day you can go to
              http://myfreeconnection.com/integrityoklahoma to get set up.
              Please remember that you must get all of the utilities required in
              your lease set up in your name prior to move in. This video
              provides some info on what they do -
              https://www.youtube.com/watch?v=9hLwHgqwVhQ&feature=youtu.be
            </p>
          </Col>
          <Col span={24}>
            <p>Move In Checklist</p>
            <p>
              You can use this link to complete your move in checklist on your
              move in date. Please take lots of pictures and let us know if you
              have any questions. https://form.jotform.com/212618481102043
            </p>
          </Col>
          <Col span={24}>
            <p>Paying Rent</p>
            <p>
              Your rent is due before move in. Rental payments can be made
              directly through our website. To make a payment, visit
              https://integrityoklahoma.com/payments/ and follow the steps to
              make a secure online payment through your bank account. You can
              also drop off checks or money orders payable to “Integrity
              Oklahoma” at our office (1800 Canyon Park Circle, Suite 202
              Edmond, Ok 73013) or mail payments to our post office box (P.O.
              Box 1451 Bethany, OK 73008). Please put your address in the
              subject line of the check or money order. If you would like to pay
              with cash you can print out the slip for paynearme from your
              tenant portal and take it to your neighborhood CVS to make a cash
              payment for your rent.
            </p>
          </Col>
          <Col span={24}>
            <p>Renters Insurance</p>
            <p>
              If you are on our Resident Benefit Program Insurance plan you will
              receive a copy of your policy by mail and email in approx 45 days.
              You can also email the carrier at
              insurancesupport@secondnature.com or by phone at 1-800-673-1289.
              To submit a claim just email claims@secondnature.com or go to this
              link
              https://claims.myinsurance.io/form-6284441/new-claim-submission-form-new-version-1-0
            </p>
            <p>
              This link has some FAQ information for renters insurance
              https://insurance.residentforms.com/faq
            </p>
            <p>
              If you already have renters insurance with another company just
              fill out this form to have the insurance charge removed from your
              account with us
              https://insurance.residentforms.com/pma-tenant-onboarding
            </p>
          </Col>
          <Col span={24}>
            <p>30 Day Notice</p>
            <p>
              When you intend to vacate the property and are in a month-to-month
              lease, you will need to give 30 days written notice. You can do
              this through your tenant portal we emailed you a link to. Each
              tenant will need to fill out the form so that we are informed the
              whole household is vacating the property. Once we have received
              your notice, we will send further move out instructions.
            </p>
          </Col>
          <Col span={24}>
            <p>Tenant responsibilities</p>
            <p>
              Be aware that there are some items you as the tenant are
              responsible for in your home. Please review your lease for a list.
              A few examples are changing the AC filters in a quarterly basis,
              Changing smoke detector batteries as needed, mowing the yard,
              taking out the trash, paying the rent on time. If a vendor is sent
              out due to a needed repair or to post a notice there can and will
              be a fee added to your ledger for you to pay if you are found to
              be at fault. Please treat the home as your own and care for it
              well so that it can be kept in great shape.
            </p>
          </Col>
          <Col span={24}>
            <p>
              I have included a link to our Tenant handbook as well that
              outlines our processes in more detail. We update this on a regular
              basis so keep this link handy.
            </p>
          </Col>
          <Col span={24}>
            <p>
              https://docs.google.com/document/d/1jhqP-sgMaMadKUJFw8qPs3F3J_li00anDNIUaFPrHv8/edit?usp=sharing
            </p>
          </Col>
          <Col span={24}>
            <p>
              below is a copy of the master insurance policy in case a tenant
              should ever ask to see it.
            </p>
          </Col>
          <Col span={24}>
            <p className="yellow-info-text">
              Email owner that the lease has been signed and what the move in
              date is
            </p>
          </Col>
          <Col span={24}>
            <Row justify="end" gutter={[8, 0]}>
              <Col>
                <Button>Skip</Button>
              </Col>
              <Col>
                <Button type="primary" onClick={handleComplete} disabled={isDisabled}>Complete</Button>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <CommentBox />
          </Col>
          <Col span={24}>
            <TaskCheckedList />
          </Col>
        </Row>
      </Form>
    </div>
  );
}

export default SendWelcomeEmail;
